import { useRouter } from "expo-router";
import { useTranslation } from "react-i18next";
import i18n from "@/i18n";

import {
  HelpButton,
  HelpIntro,
  HelpScreen,
  HelpSection,
  InfoNote,
} from "@/components/help/help-ui";

const ideas = () => [
  i18n.t("help.feedback.items.features"),
  i18n.t("help.feedback.items.screens"),
  i18n.t("help.feedback.items.wording"),
  i18n.t("help.feedback.items.safety"),
  i18n.t("help.feedback.items.plus"),
  i18n.t("help.feedback.items.groups"),
];

export default function Feedback() {
  useTranslation();
  const router = useRouter();

  return (
    <HelpScreen title={i18n.t("help.feedback.title")}>
      <HelpIntro>{i18n.t("help.feedback.intro")}</HelpIntro>

      <HelpSection
        heading={i18n.t("help.feedback.heading")}
        bullets={ideas()}
      />

      <InfoNote>{i18n.t("help.feedback.note")}</InfoNote>

      <HelpButton
        label={i18n.t("help.feedback.send")}
        icon="bulb-outline"
        onPress={() => router.push("/help/contact?source=feedback")}
      />
    </HelpScreen>
  );
}
